import { CreativesFilters, CreativeStatus } from 'components/common/types/Creative.types';

export const mapStatusFilter = (filterData: Pick<CreativesFilters, 'status' | 'automatic'>): string | undefined => {
  const statuses = filterData.status;

  if (!statuses?.length) {
    return undefined;
  }

  const { automatic } = filterData;

  const rejectedTokens = [
    automatic !== 'false' && `${CreativeStatus.REJECTED}:true`,
    automatic !== 'true' && `${CreativeStatus.REJECTED}:false`,
  ].filter((token): token is string => Boolean(token));

  const tokens = [
    ...statuses.filter((status) => status !== CreativeStatus.REJECTED),
    ...(statuses.includes(CreativeStatus.REJECTED) ? rejectedTokens : []),
  ];

  return tokens.length ? tokens.join(',') : undefined;
};
